import {
  createClient as createSupabaseClient,
  SupabaseClient,
} from '@supabase/supabase-js'
import type { Database } from './types'

export type TypedSupabaseClient = SupabaseClient<Database>

/**
 * Create a Supabase client for browser usage (Vite/React)
 * Persists session in localStorage
 */
export function createBrowserClient(
  supabaseUrl: string,
  supabaseAnonKey: string,
  options?: {
    storageKey?: string
  }
): TypedSupabaseClient {
  return createSupabaseClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      storageKey: options?.storageKey ?? 'sb-limo-auth',
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      // Disable browser tab locking to prevent hanging on session restoration
      lock: async (_name, _acquireTimeout, fn) => fn(),
    },
  })
}

/**
 * Create a Supabase client for server usage (Next.js API routes, SSR)
 * Does not persist session
 */
export function createServerClient(
  supabaseUrl: string,
  supabaseAnonKey: string
): TypedSupabaseClient {
  return createSupabaseClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
    },
  })
}

// Re-export for convenience
export { createSupabaseClient }
